import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    routes: (count: number) => translate({ id: 'global.counter.routes', values: { count } }),
    summaryConstraints: (count: number) =>
      translate({ id: 'rm.summary.constraints', values: { count } }),
    summaryViolations: (count: number) =>
      translate({ id: 'rm.summary.violations', values: { count } }),
  }))

  return api
}
